<template>
  <v-navigation-drawer :model-value="view" location="right" :scrim="false"
    :style="view ? 
      { right, width }
      : { right: '0px', width: '0px' }" 
    elevation="10" temporary>
    <OperationalComponent 
      type="configure" 
      :icon="iconComponent(action?.type)" 
      :title="titleComponent(action?.type)"
      @confirmDialog="onConfigureClick"
      :denyEnabled="false">
       <TriggerActionEmailComponent v-if="action?.type == TriggerActionTypeEnum.EMAIL_ACTION" :action="action" />
       <TriggerActionWebhookComponent v-if="action?.type == TriggerActionTypeEnum.WEBHOOK_ACTION" :action="action" /> 
       <TriggerActionTelegramComponent v-if="action?.type == TriggerActionTypeEnum.TELEGRAM_ACTION" :action="action" /> 
       <TriggerActionTeamsComponent v-if="action?.type == TriggerActionTypeEnum.TEAMS_ACTION" :action="action" /> 
    </OperationalComponent>
  </v-navigation-drawer>
</template>

<script lang="ts">
import OperationalComponent from '../UIComponents/OperationalComponent.vue'
import AnimatedButton from "../UIComponents/AnimatedButton.vue";
import { AvailableActions, TriggerActionTypeEnum } from './type.util'
import TriggerActionEmailComponent from './TriggerActionEmailComponent.vue';
import TriggerActionWebhookComponent from './TriggerActionWebhookComponent.vue';
import TriggerActionTelegramComponent from './TriggerActionTelegramComponent.vue';
import TriggerActionTeamsComponent from './TriggerActionTeamsComponent.vue';

export default {
  emits: ["actionConfigured"], 
  name: "ConfigureAction",
  components: {
    AnimatedButton,
    OperationalComponent,
    TriggerActionEmailComponent,
    TriggerActionWebhookComponent,
    TriggerActionTelegramComponent,
    TriggerActionTeamsComponent,
  },
  data() {
    return {
      TriggerActionTypeEnum,
    }
  },
  props: {
    action: {
      type: Object as () => AvailableActions,
      default: undefined,
    },
    view: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    iconComponent(type) {
      switch (type) {
        case TriggerActionTypeEnum.EMAIL_ACTION:
          return 'ecc:ecc-TRIG-action';
        default:
          return 'ecc:ecc-TRIG-action';
      }
    },
    titleComponent(type) {
      switch (type) {
        case TriggerActionTypeEnum.EMAIL_ACTION:
          return this.$t('configureEmail');
        case TriggerActionTypeEnum.TELEGRAM_ACTION:
          return this.$t('configureTelegramMessage');
        case TriggerActionTypeEnum.TEAMS_ACTION:
          return this.$t('configureTeamsMessage');
        default:
          return this.$t('configureWebhook');
      }
    },
    async onConfigureClick() {
      this.$emit('actionConfigured', this.action);
    }
  },
  computed: {
    width() {
      switch (this.$vuetify.display.name) {
        case 'xs': return "100%";
        case 'sm': return "50%";
        default: return "500px";
      }
    },
    right() {
      switch (this.$vuetify.display.name) {
        case 'xs': return "100%";
        case 'sm': return "50%";
        default: return "500px";
      }
    },
  }
};
</script>

<style scoped>
.header {
  font-weight: bold;
}
</style>
